import React, { useContext, useEffect, useRef, useState } from 'react';
import Switch from "react-switch";

import BasicDropdown from "../../SharedComponents/Forms/BasicDropdown";
import RadioButtons from "../../SharedComponents/Forms/RadioButtons";
import SvgIcon from "../../SharedComponents/Icons";
import { Context } from '../index';
import CheckboxFilter from "./CheckboxFilter";
import FiltersDropdown from "./FiltersDropdown";
import SearchAreaFilter from "./SearchAreaFilter";
import RangeSelector from "./RangeSelector";

import './index.sass';


const Filters = () => {

  const {
    facilitiesOptions,
    generateBreadcrumbs,
    mainCategories,
    mapIsOpen,
    numberOfGuests,
    ownCatering,
    priceSelector,
    regionsOptions,
    selectedFacilities,
    selectedSuitableKinds,
    selectedTypes,
    setBreadcrumbs,
    setCoords,
    setNumberOfGuests,
    setOwnCatering,
    setPage,
    setPriceSelector,
    setSelectedDistrict,
    setSelectedFacilities,
    setSelectedPrice,
    setSelectedRegion,
    setSelectedSuitableKinds,
    setSelectedTypes,
    suitableOptions,
    updateUrlParameters,
  } = useContext(Context);

  const [isOpen, setIsOpen] = useState(false);
  const [selectedType, setSelectedType] = useState(null);

  const modalWrapperRef = useRef();

  const typesOptions = mainCategories && mainCategories.length && mainCategories.map(categoryGroup => ({
    categories: categoryGroup.categories,
    icon: categoryGroup.key,
    id: categoryGroup.id,
    label: categoryGroup.name,
    checked: selectedType && selectedType.id === categoryGroup.id,
    value: categoryGroup.id,
  }));

  const typesDropdownOptions = [ { id: 0, icon: 'graph', label: 'Alle' }, ...typesOptions ];
  const typesRadioOptions = [ ...typesOptions, { value: 0, label: 'Alle typer', checked: selectedType ? selectedType.id === 0 : true } ];


  useEffect(() => {
    return () => window.removeEventListener('click', handleClickOutside, true);
  }, []);


  useEffect(() => {
    if (selectedTypes && selectedTypes.length && !selectedType) {
      typesOptions.map(option => {
        selectedTypes.every(typeId => option.categories.includes(typeId)) && setSelectedType(option);
      });
    }
  }, [selectedTypes]);


  const toggleFilters = () => {
    if (isOpen) {
      setIsOpen(false);
      window.removeEventListener('click', handleClickOutside, true);
      document.body.classList.toggle('mobile-filters-open');
    } else {
      setIsOpen(true);
      window.addEventListener('click', handleClickOutside, true);
      document.body.classList.toggle('mobile-filters-open');
    }
  };


  const handleClickOutside = (event) => {
    const wrapper = modalWrapperRef && modalWrapperRef.current;
    const target = event.target;
    const isWrapper = wrapper && (target === wrapper || wrapper.contains(target));

    if (wrapper && !isWrapper) {
      setIsOpen(false);
      document.body.classList.remove('mobile-filters-open');
    }
  };


  const handlePriceSelector = (value, setPrice) => {
    setPriceSelector(value);
    setPrice && handlePriceSelectorChange(value);
  };


  const handlePriceSelectorChange = (value) => {
    const price = value || priceSelector;
    const isDefault = price && price.min === 0 && price.max === 500;
    setSelectedPrice(price);
    setPage(1);
    updateUrlParameters({ price_per_seat_from: isDefault ? '' : price.min, price_per_seat_to: isDefault ? '' : price.max, page: '' })
  };


  const handleTypesSelect = (id) => {
    const currentOption = typesDropdownOptions.find(type => type.id === id);
    const selectedTypesIds = id === 0 ? [] : currentOption.categories;

    setSelectedType(currentOption);
    setSelectedTypes(selectedTypesIds);
    setPage(1);
    updateUrlParameters({ categories: selectedTypesIds, page: '' });
  };


  const handleGuestsNumber = (value) => {
    setNumberOfGuests(value);
    setPage(1);
    updateUrlParameters({ guest_capacity: value, page: '' });
  };


  const handleCheckboxesData = (setData) => {
    setData();
    setPage(1);
  };


  const handleCatering = (state) => {
    setOwnCatering(state);
    updateUrlParameters({ permits_own_catering: state, page: 1 });
  };


  const selectedTypeLabel = selectedType && selectedType.id !== 0 && [selectedType.label];
  const selectedSuitableKindsLabel = selectedSuitableKinds && selectedSuitableKinds.map(id => suitableOptions.find(option => option.id === id).name);
  const selectedFacilitiesLabel = selectedFacilities && selectedFacilities.map(id => facilitiesOptions.find(option => option.id === id).name);
  const selectedPriceLabel = ((priceSelector.min && priceSelector.min > 0) || (priceSelector.max && priceSelector.max !== 500))
    ? [`${priceSelector.min} - ${priceSelector.max} kr.`] : null;


  return (
    <div className="filters">

      <div className="filters__left-part">

        <div className="filters__form-group regions search-area">
          <SearchAreaFilter
            generateBreadcrumbs={generateBreadcrumbs}
            regionsOptions={regionsOptions}
            setBreadcrumbs={setBreadcrumbs}
            setCoords={setCoords}
            setPage={setPage}
            setSelectedDistrict={setSelectedDistrict}
            setSelectedRegion={setSelectedRegion}
          />
        </div>

        <div className={`filters__form-group guests-number ${mapIsOpen ? 'with-map' : ''}`}>
          <SvgIcon name="users2" size={16} />
          <input
            className="filters__guests-number-input"
            inputMode="numeric"
            min="0"
            onChange={(e) => (/^\d+$/.test(e.target.value) || !e.target.value) && handleGuestsNumber(e.target.value)}
            pattern="[0-9]*"
            placeholder={'Antal gæster'}
            type="text"
            value={numberOfGuests || ''}
          />
        </div>

        <div className={`filters__form-group types ${mapIsOpen ? 'with-map' : ''}`}>
          <BasicDropdown
            currentValue={selectedType}
            handleChange={(value) => handleTypesSelect(value.id)}
            handleSetValue={(value) => setSelectedType(value)}
            options={typesDropdownOptions}
            placeholder="Lokaletype"
            triggerIcon="graph"
          />
        </div>
      </div>

      <div className={`filters__modal ${mapIsOpen ? 'with-map' : 'with-margin'}`} ref={modalWrapperRef}>
        <div className="filters__toggle" id="filters-toggle" onClick={toggleFilters}>
          <SvgIcon name="filter" size={16} className="filters__toggle-icon"/>
          <p className="filters__toggle-label">Filtre</p>
        </div>

        { isOpen &&
          <div className="filters__modal-wrapper">

            <div className="filters__modal-headline">
              <SvgIcon
                name='close'
                onClick={toggleFilters}
                size={32}
              />
              Filtre
            </div>

            <FiltersDropdown
              className="mobile"
              header="Lokaletype"
              selectedFilters={selectedTypeLabel}>
              <RadioButtons
                handleChange={handleTypesSelect}
                name="types"
                options={typesRadioOptions}
              />
            </FiltersDropdown>

            <FiltersDropdown
              className="desktop-hidden suitable"
              header="Velegnet til"
              selectedFilters={selectedSuitableKindsLabel}>
              <CheckboxFilter
                options={suitableOptions}
                paramName="suitable_for_kinds"
                selected={selectedSuitableKinds}
                setData={(newData) => handleCheckboxesData(() => setSelectedSuitableKinds(newData))}
                updateUrl={updateUrlParameters}
              />
            </FiltersDropdown>

            <FiltersDropdown
              className="as-switch"
              header="Egen forplejning">
              <Switch
                onChange={handleCatering}
                checked={ownCatering}
                uncheckedIcon={false}
                onHandleColor="#E8753D"
                offHandleColor="#444444"
                onColor="#FFFCF3"
                offColor="#FFFFFF"
                height={20}
                width={35}
                checkedIcon={false}
                id="permits_own_catering"
                className="list-view__switch"
              />
            </FiltersDropdown>

            <FiltersDropdown
              header="Pris"
              selectedFilters={selectedPriceLabel}>
              <RangeSelector
                showInputLabels={true}
                minValue={0}
                maxValue={500}
                value={priceSelector}
                dimension={'kr.'}
                handleSelectorChange={handlePriceSelector}
                filterLocations={handlePriceSelectorChange}
                filterType='PRICE'
                showMaxMoreIcon={true}
                showInputLabels={true}
              />
            </FiltersDropdown>

            <FiltersDropdown
              className="mobile"
              header="Antal gæster"
              selectedFilters={[numberOfGuests]}>
              <input
                className="filters__guests-number-input"
                onChange={(e) => (/^\d+$/.test(e.target.value) || !e.target.value) && handleGuestsNumber(e.target.value)}
                placeholder={'Antal gæster'}
                type="text"
                value={numberOfGuests || ''}
              />
            </FiltersDropdown>

            <FiltersDropdown
              className="facilities"
              header="Faciliteter"
              selectedFilters={selectedFacilitiesLabel}>
              <CheckboxFilter
                options={facilitiesOptions}
                paramName="facilities"
                selected={selectedFacilities}
                setData={(newData) => handleCheckboxesData(() => setSelectedFacilities(newData))}
                updateUrl={updateUrlParameters}
              />
            </FiltersDropdown>
            <div className="filters__submit-btn" onClick={toggleFilters}>
              Andvend filter
            </div>
          </div>
        }
      </div>

    </div>
  )
}

export default Filters;
